import { Avatar, Breadcrumb, Button, Col, Dropdown, Menu, Row, Space, Typography } from "antd";
import { KeyOutlined, LogoutOutlined, MenuOutlined, UserOutlined } from "@ant-design/icons";
import { Link, NavLink } from "react-router-dom";

const { Text } = Typography;

const pageNames = {
  dashboard: "Dashboard",
  providers: "Nhà cung cấp AI",
  assistants: "Trợ lý AI",
  flows: "Quản lý Flow",
  scripts: "Kịch bản",
  "google-workspace": "Google Drive & Sheets",
  "video-tools/ffmpeg": "Render FFmpeg",
  "auto-upload/groups": "Upload Groups",
  "auto-upload/channels": "YouTube Channels",
  "auto-upload/tiktok-accounts": "TikTok Accounts",
  "auto-upload/facebook-pages": "Facebook Pages",
  "auto-upload/configs": "Cấu hinh Reup",
  "auto-upload/configs/new": "Tạo cấu hinh Reup",
  "system/users": "Quản lý người dùng",
  "system/app-params": "Tham số ứng dụng",
  "system/workers": "Worker Agents",
  "system/feedbacks": "Lỗi phản ánh",
  profile: "Thông tin tài khoản",
};

function getPageName(pathParts) {
  const path = pathParts.join("/");
  if (pageNames[path]) return pageNames[path];
  if (path.startsWith("auto-upload/configs/")) return "Cấu hinh Reup";
  if (path.startsWith("flows/")) return "Cấu hình Flow";
  if (path.startsWith("scripts/")) return "Kịch bản";
  return pageNames[pathParts[0]] || pathParts[0] || "Dashboard";
}

export default function Header({ name = "", onPress }) {
  const pathParts = name.split("/").filter(Boolean);
  const pageName = getPageName(pathParts);
  const username = localStorage.getItem("autotuber_username") || "Người dùng";

  const accountMenu = (
    <Menu className="account-dropdown">
      <Menu.Item key="user" disabled>
        <Space>
          <Avatar size="small" icon={<UserOutlined />} />
          <div>
            <Text strong>{username}</Text>
            <br />
            <Text type="secondary">Tài khoản Auto Upload</Text>
          </div>
        </Space>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="profile" icon={<KeyOutlined />}>
        <Link to="/profile">Thông tin tài khoản</Link>
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link to="/logout">Đăng xuất</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Row gutter={[16, 0]} align="middle">
      <Col flex="auto">
        <Breadcrumb>
          <Breadcrumb.Item><NavLink to="/dashboard">Trang chủ</NavLink></Breadcrumb.Item>
          <Breadcrumb.Item>{pageName}</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
      <Col className="header-control">
        <Button type="text" className="sidebar-toggler" icon={<MenuOutlined />} onClick={onPress} />
        <Dropdown overlay={accountMenu} trigger={["click"]} placement="bottomRight">
          <Button type="text" className="header-account-button">
            <Space>
              <span className="header-account-icon"><UserOutlined /></span>
              <span className="header-account-copy">
                <Text strong>{username}</Text>
                <Text type="secondary">Đang đăng nhập</Text>
              </span>
            </Space>
          </Button>
        </Dropdown>
      </Col>
    </Row>
  );
}
